import { render, staticRenderFns } from "./DoclibCard.vue?vue&type=template&id=5ea56a98&scoped=true"
import script from "./DoclibCard.vue?vue&type=script&lang=js"
export * from "./DoclibCard.vue?vue&type=script&lang=js"
import style0 from "./DoclibCard.vue?vue&type=style&index=0&id=5ea56a98&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea56a98",
  null
  
)

export default component.exports